import { CloseTabButton, Container, Tab, TabButton } from './Tabs.styles'

export interface TabsProps {
  items:  | string[]
  actual: any
  isEditable?: boolean
  newTabLabel?: string
  onAddTab?: () => void
  onRemoveTab?: (tabIndex: number) => void
  onSelectNewTab?: (tabIndex: number) => void
}

export const Tabs = ({ items, actual, isEditable, onRemoveTab, onSelectNewTab }: TabsProps) => {
  return (
    <Container>
      {items.map((item, index) => (
        <Tab key={`${item}@${index}`}>
          <TabButton
            type='button'
            actual={actual === index}
            onClick={() => onSelectNewTab?.(index)}
            aria-label='select tab'>
            {item}
          </TabButton>
          {isEditable && items.length > 1 && (
            <CloseTabButton
              className='close'
              type='button'
              onClick={() => onRemoveTab?.(index)}
              actual={actual === index}
              aria-label='remove tab'>
            </CloseTabButton>
          )}
        </Tab>
      ))}
    </Container>
  )
}
